if (window.location.hostname == 'gdpr-macs.clicmap.fr') {
    window.urlapi = "https://gdpr-macs-api.clicmap.fr/api/";
    window.apiClicmap = "https://api.clicmap.fr/"
    window.urlDocOpen = "https://gdpr-macs-api.clicmap.fr/docOpen.php?id="
    window.urlDocView = "https://gdpr-macs-api.clicmap.fr/docView.php?id="
}else if (window.location.hostname == 'gdpr-macs-preprod.clicmap.fr') {
    window.urlapi = "https://gdpr-macs-api-preprod.clicmap.fr/api/";
    window.apiClicmap = "https://api-dev.clicmap.fr/"
    window.urlDocOpen = "https://gdpr-macs-api-preprod.clicmap.fr/docOpen.php?id="
    window.urlDocView = "https://gdpr-macs-api-preprod.clicmap.fr/docView.php?id="
} else {
    window.urlapi = "https://gdpr-macs-dev-api.clicmap.fr/api/";
    window.apiClicmap = "https://api-dev.clicmap.fr/"
    window.urlDocOpen = "https://gdpr-macs-dev-api.clicmap.fr/docOpen.php?id="
    window.urlDocView = "https://gdpr-macs-dev-api.clicmap.fr/docView.php?id="
}

window.apiElise = "https://ccmacs.illico.city/GED/Elise/WebServiceApplication/EliseWebService.svc/soapOperation";
window.IGNkey = "pratique";
window.ADDRESSAPI = "https://data.geopf.fr/geocodage/search/?q="
window.ADDRESSREVERSEAPI = "https://data.geopf.fr/geocodage/reverse/"
window.mapFile = "/var/www/html/ress/cc_macs/cc_macs.map"
window.url_mapProxy = 'https://mapproxy.clicmap.fr/mapproxy/service';
window.url_mapServer = "https://mapserver.clicmap.fr/cgi-bin/mapserv";
window.mail_reorientation = "utdsoustons@landes.fr";